import React from 'react';
import BlockDates from './BlockDates';

const DateTime = () => {
  return <BlockDates />;
};

export default DateTime;
